/* eslint-disable import/no-unresolved */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import React, { useCallback, useState, useEffect } from 'react';
import Dropzone from 'react-dropzone';
import setClass from '../../common/set-class';
import useAfterMount from '../../hooks/use-after-mount';
import toMb from './logic/to-mb';
import toImage from './logic/to-image';
import Icon from '../icon';
const defaultTip = (React.createElement(React.Fragment, null,
    React.createElement(Icon, { name: "file-arrow-up" }),
    React.createElement("p", { className: "b-txt" },
        "Drop image here or",
        ' ',
        React.createElement("a", { href: "", onClick: (e) => e.preventDefault(), className: "b-alink" }, "upload"))));
const LogoUploader = (props) => {
    const { icon, style, className, onImage, maxSizeAllowed = 4e6, disabled = false, defaultIcon, onSelect = () => { }, canRemove, onRemove = () => { }, largePreview = false, smallPreview = false, accept = 'image/*', isDarkMode = false, previewClass = '', validators, runValidatorsOn = [], renderTip, } = props;
    const isAfterMount = useAfterMount();
    const [image, setImage] = useState({ dataUrl: '' });
    const [imgSrc, setImgSrc] = useState();
    const [error, setError] = useState();
    const [isHoverPreview, setIsHoverPreview] = useState(false);
    const onDrop = useCallback((files) => {
        /* gets called when dropped, arg passed in is files */
        const file = files[0];
        toImage(file)
            .then((img) => onSelect(img))
            .catch(console.log);
    }, []);
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
    const onDropAccepted = useCallback((acceptedFiles) => {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
        setError(null);
        const file = acceptedFiles[0];
        if (validators) {
            toImage(file)
                .then((theImage) => {
                const errors = validators
                    .map((vdator) => vdator(file, theImage))
                    .filter(Boolean);
                if (errors.length) {
                    setError({
                        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ type: string; message: any; }'... Remove this comment to see the full error message
                        type: 'custom',
                        message: errors[0],
                    });
                }
                else {
                    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
                    setImage(theImage);
                }
            })
                .catch(console.log);
        }
    });
    const onDropRejected = useCallback(() => {
        /* gets call when rejected, arg is 'fileRejections' */
    }, []);
    useEffect(() => {
        // Icon can either be an icon object or a url/base64 of the icon.
        if (icon?.dataUrl || typeof icon === 'string') {
            setImgSrc(icon.dataUrl || icon);
        }
        else {
            onDropAccepted([defaultIcon]);
        }
    }, [icon, defaultIcon]);
    /* set the image when it's set */
    useEffect(() => {
        if (image.dataUrl) {
            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
            setImgSrc(image.dataUrl);
            if (onImage) {
                onImage(image);
            }
        }
    }, [image]);
    useEffect(() => {
        if (validators && isAfterMount) {
            const errors = validators
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'file' does not exist on type '{ dataUrl:... Remove this comment to see the full error message
                .map((vdator) => vdator(image?.file, image))
                .filter(Boolean);
            if (errors.length) {
                setError({
                    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ type: string; message: any; }'... Remove this comment to see the full error message
                    type: 'custom',
                    message: errors[0],
                });
            }
            else {
                // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
                setError();
            }
        }
    }, runValidatorsOn);
    const validator = useCallback((file) => {
        if (file.size > maxSizeAllowed) {
            setError({
                // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ type: string; message: string;... Remove this comment to see the full error message
                type: 'max-size',
                message: `Upload a file that has a max file size of ${toMb(maxSizeAllowed)} MB.`,
            });
        }
    }, []);
    return (React.createElement("div", { style: style, className: setClass([
            'k-library-org-logo',
            largePreview && '--large-preview',
            className,
            disabled && 'k-library-org-logo--disabled',
        ]) },
        React.createElement("div", { className: setClass(previewClass, 'k-library-org-logo__preview', smallPreview && '--small-preview', largePreview && '--large-preview', error && '--has-error', canRemove && isHoverPreview && 'k-library-org-logo__preview--delete', isDarkMode && '--dark-mode'), onClick: () => {
                if (canRemove) {
                    onRemove();
                    setImage({ dataUrl: '' });
                    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
                    setImgSrc();
                    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                    setError(null);
                }
            }, onMouseEnter: () => setIsHoverPreview(true), onMouseLeave: () => setIsHoverPreview(false) },
            canRemove && isHoverPreview ? (React.createElement("div", { className: "k-library-org-logo__preview__delete-overlay" },
                React.createElement(Icon, { name: "trash-can" }))) : null,
            React.createElement("img", { src: imgSrc, alt: "Company Logo" })),
        React.createElement("div", { className: "k-library-org-logo__uploader" },
            React.createElement(Dropzone, { disabled: disabled, 
                // @ts-expect-error ts-migrate(2322) FIXME: Type '(file: any) => void' is not assignable to ty... Remove this comment to see the full error message
                validator: validator, onDropAccepted: onDropAccepted, onDropRejected: onDropRejected, accept: accept, maxSize: maxSizeAllowed, onDrop: onDrop }, ({ getRootProps, getInputProps, isDragActive }) => (React.createElement("div", { className: setClass([
                    'k-library-org-logo__droparea',
                    isDragActive && 'k-library-org-logo__droparea--active',
                ]), ...getRootProps() },
                React.createElement("input", { ...getInputProps() }),
                renderTip?.({ icon: React.createElement(Icon, { name: "file-arrow-up" }) }) ||
                    defaultTip)))),
        error && (React.createElement("div", { className: "k-library-org-logo__error" },
            React.createElement(Icon, { name: "triangle-exclamation" }),
            React.createElement("p", { className: "b-txt" }, error.message)))));
};
// eslint-disable-next-line import/prefer-default-export
export { LogoUploader };
